module.exports = __webpack_public_path__ + "static/img/diamond.43abb39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/diamond.png
// module id = OwTq
// module chunks = 0